import React from "react";
import Navbar from "./Content/Navbar";
import Main from './Content/Main';
import Particle from "./Content/Particle";
import Typing from "./Content/Typing";
import {Routes, Route} from 'react-router-dom';
import AboutMe from "../src/Content/AboutMe";
import Blog from "../src/Content/Blog";
import Projects from "../src/Content/Projects";
import Contact from "../src/Content/Contact";



function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Main />}/>
        <Route path='aboutme' element={<AboutMe />}/>
        <Route path='blog' element={<Blog />}/>
        <Route path='projects' element={<Projects />}/>
        <Route path='contact' element={<Contact />} />
      </Routes> 

      <div className="arrow-top">
        <a className="arrow-top-link" href="#top">
          <i class="fa-solid fa-arrow-up"></i>
        </a>
      </div>
      
    </div>
  );
}

export default App;
